module.exports = __webpack_public_path__ + "img/lrb_logo.fd83c6a0.png";